export enum AdvertisementPublicationPeriodEnum {
  TWO_WEEKS = '2W',
  ONE_MONTH = '1M',
  THREE_MONTHS = '3M',
  SIX_MONTHS = '6M',
}
